import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
// import SubscriptionGuard from '~/guards/SubscriptionGuard';

const ForgotPassword = lazy(() => import('~/pages/auth/forgot-password/forgot-password'));
const ResetPassword = lazy(() => import('~/pages/auth/reset-password/reset-password'));
const Signup = lazy(() => import('~/pages/auth/signup/signup'));
const VerifyEmail = lazy(() => import('~/pages/auth/verify-email/verify-email'));
const Home = lazy(() => import('~/pages/dashboard/home/home'));
const Videos = lazy(() => import('~/pages/dashboard/videos/videos'));
const Insights = lazy(() => import('~/pages/dashboard/insights/insights'));
const VideoInsights = lazy(() => import('~/pages/dashboard/video/video'));
const DetailAnalytics = lazy(() => import('~/pages/dashboard/detail-analytics/detail-analytics'));
const Studio = lazy(() => import('~/pages/dashboard/studio/studio'));
const Profile = lazy(() => import('~/pages/dashboard/profile/profile'));
const Checkout = lazy(() => import('~/pages/dashboard/checkout/checkout'));
const Billing = lazy(() => import('~/pages/dashboard/billing/billing'));
const Invoice = lazy(() => import('~/pages/dashboard/billing/invoice'));
// const WatchLater = lazy(() => import('~/pages/dashboard/watch-later/watch-later'));
const Notification = lazy(() => import('~/pages/dashboard/notification/notification'));

const Login = lazy(() => import('~/pages/auth/login/login'));
const Video = lazy(() => import('~/pages/video/preview'));

const UploadVideo = lazy(() => import('~/pages/dashboard/upload-video/upload-video'));
const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/auth/reset-password/:token" element={<ResetPassword />} />
      <Route path="/onboard/:token/verify" element={<VerifyEmail />} />
      <Route path="/onboard" element={<VerifyEmail />} />

      <Route path="/video/:key" element={<Video />} />
      <Route path="/v/:key" element={<Video />} />

      {/* private routes authenticated by withlayout */}
      {/* <Route element={<SubscriptionGuard />}> */}
      <Route path="/" element={<Home />} />
      <Route path="/upload-video" element={<UploadVideo />} />
      <Route path="/videos" element={<Videos />} />
      <Route path="/insights/video/:videoKey" element={<VideoInsights />} />
      <Route path="/insights/:kind/:name" element={<Insights />} />
      <Route path="/analytics/:kind/:id" element={<DetailAnalytics />} />
      <Route path="/video/studio/:key" element={<Studio />} />
      {/* </Route> */}
      <Route path="/profile" element={<Profile />} />
      {/* working on these under development */}
      <Route path="/checkout" element={<Checkout />} />
      <Route path="/checkout/:checkout_id/:status" element={<Checkout />} />
      <Route path="/billing" element={<Billing />} />
      <Route path="/billing/invoices/:invoiceId" element={<Invoice />} />
      {/* <Route path="/coming-soon" element={<ComingSoon />} /> */}
      {/* <Route path="/watch-later" element={<WatchLater />} /> */}
      <Route path="/notification" element={<Notification />} />
      {/* <Route path="/analytics" element={<Analytics />} /> */}
      {/* <Route path="/notifications" element={<NotificationsPage />} />*/}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;
